<template>
  <div class="container">
    <img
      src="../assets/cap_loading.gif"
      style="width: 350px"
    />
  </div>
</template>

<script>
export default {
  name: "Loading"
};
</script>